import PropTypes from "prop-types";
import React from "react";
import { GiGrass } from "react-icons/gi";
import DMR from "../../assets/waste_icons/DMR.svg";
import GEN from "../../assets/waste_icons/GEN.svg";
import GLS from "../../assets/waste_icons/GLS.svg";
import CRD from "../../assets/waste_icons/CRD.svg";
import FOD from "../../assets/waste_icons/FOD.svg";
import MandV from "../../assets/waste_icons/M&V.svg";
import WEEE from "../../assets/waste_icons/WEEE.svg";

const WasteIcon = ({ wasteType }) => {
  const wasteTypeIconLookup = {
    CRD: <img src={CRD} className="size-full object-contain" alt="Cardboard" />,
    DMR: (
      <img
        src={DMR}
        className="size-full object-contain"
        alt="Dry-Mixed Recycling"
      />
    ),
    FOD: <img src={FOD} className="size-full object-contain" alt="Food" />,
    GEN: <img src={GEN} className="size-full object-contain" alt="General" />,
    GLS: <img src={GLS} className="size-full object-contain" alt="Glass" />,
    WEEE: (
      <img
        src={WEEE}
        className="size-full object-contain"
        alt="Electrical and Electronic Equipment"
      />
    ),
    GAR: <GiGrass className="size-full object-contain" alt="Grass" />,
    "M&V": (
      <img src={MandV} className="size-full object-contain" alt="Man and Van" />
    ),
  };

  return <>{wasteTypeIconLookup[wasteType]}</>;
};
WasteIcon.propTypes = {
  wasteType: PropTypes.string.isRequired,
};
export default WasteIcon;
